import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, Typography } from '@material-ui/core'

import { LoadingFeedback } from 'components'

import helpers from 'helpers'

const ListInviteAdvisor = ({
  setDisabled,
  invite,
  loading,
  inviteTypeText,
}) => {
  useEffect(() => {
    setDisabled(true)
    //eslint-disable-next-line
  }, [invite])

  return (
    <Box mt={2}>
      <LoadingFeedback open={loading} />
      {invite ? (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Nome
            </Typography>
            <Typography color="textPrimary" variant="body2">
              {invite?.name || 'Não informado'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Email
            </Typography>
            <Typography color="textPrimary" variant="body2">
              {invite?.email || 'Não informado'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Status
            </Typography>
            <Typography color="textPrimary" variant="body2">
              {helpers.inviteAdvisor.statusLabel(invite?.status) ||
                'Não informado'}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Box m={3}>
          <Typography color="textPrimary" variant="body1">
            Não existe nenhum {inviteTypeText} vinculado à empresa.
          </Typography>
        </Box>
      )}
    </Box>
  )
}

ListInviteAdvisor.propTypes = {
  setDisabled: PropTypes.func,
  invite: PropTypes.object,
  loading: PropTypes.bool,
  inviteTypeText: PropTypes.string,
}

ListInviteAdvisor.defaultProps = {
  setDisabled: () => {},
  invite: {},
}

export default ListInviteAdvisor
